import React, { useState, useEffect, useCallback } from "react";
import {
  Box, Grid, TextField, FormControl, InputLabel, Select, MenuItem,
  Checkbox, FormControlLabel, Typography, Button, Switch, Divider, Paper,
  FormHelperText,
  Autocomplete,
  CircularProgress,
  debounce,
} from "@mui/material";
import axios from "axios";
import { get, put } from "src/services/httpClient.service";
import { useSnackbar } from "src/components/snackbar/useSnackbar";
import { authenticationService } from "src/services/authentication.service";
import { useParams, useNavigate } from 'react-router-dom';
import { useAppConfig } from "src/components/AppConfigContext/AppConfigContext";

import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

interface EditUserProps {
  operatorId: string;          // Pass selected user ID to edit
  onClose: () => void;     // Close handler
  onSuccess: () => void;   // Callback on success
}

const API_URL = process.env.REACT_APP_BASE_API_URL;

const EditOperator: React.FC<EditUserProps> = ({ operatorId, onClose, onSuccess }) => {
  const { id } = useParams<{ id: string }>();
  const { isLcoId } = useAppConfig();

  const navigate = useNavigate()
  const [formData, setFormData] = useState({
    companyId: "",
    company: "",
    //role: "", 
    operatorName: "",
    email: "",
    password: "",
    mobile: "",
    phone: "",
    address1: "",
    address2: "",
    areaId: "",
    accountType: "",
    zone: "",
    lcoId: "",
    distributorId: "",
    franchiseId: "",
    franchisees: [] as string[], 
    selectAll: false,
    enableFreeAccess: false, 
    allowNstvIrdCondition: false, 
    allowLowBalanceRecharge: false, 
    status: true,
    roleIdsList: [] as string[], 
    franchiseIdsList: [] as string[], 
    vendorId: "",
    franchiseName: '',
    franchiseCode: '',
    billingTaxId:'',
    priceListId: '',
    openingAmount: '',
    creditLimit: ''
  });

  const [loading, setLoading] = useState(false);
  const [states, setStates] = useState<string[]>([]);
  const [cities, setCities] = useState<string[]>([]);
  const [loadingCities, setLoadingCities] = useState(false);
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [zonesList, setZonesList] = React.useState([]);
  const [showLcoId, setShowLcoId] = useState(false);

  const [showPassword, setShowPassword] = useState(false);

  const franchiseeList = ["Franchisee A", "Franchisee B", "Franchisee C", "Franchisee D"];

  const { showSnackbar } = useSnackbar();
  const { vendorId, franchiseId } = authenticationService.getVendorFranchiseIds();
  const [companiesList, setCompanies] = React.useState([]);
  const [franchiseList, setFranchisees] = React.useState([]);
  const [distributorsList, setDistributorsList] = React.useState([]);
  const [rolesList, setRoles] = React.useState([]);
  const [areaList, setAreaList] = React.useState([]);
  const [selectedBillingAreaId, setSelectedBillingAreaId] = React.useState('');
  const operatorTypeAccount = localStorage.getItem('operatorData')
  const operatorAccountConvert = JSON.parse(operatorTypeAccount)
  const [operatorAccountType, setOperatorAccountType] = useState<any>(operatorAccountConvert?.accountType)
  const accountType = localStorage.getItem('accountType');
  const [areaOpen, setAreaOpen] = useState(false);

  const [priceLists, setPriceLists] = React.useState([]);
  const [billingTaxTypes, setBillingTaxTypes] = React.useState([]);


  const fetchCompanies = async () => {
    try {
      const response = await get(`${API_URL}/api/company/vendor/${vendorId}/fetchAll`);
      if (response && Array.isArray(response)) {
        setCompanies(response);
        return response;
      } else {
        console.error("Unexpected API response:", response);
        return [];
      }
    } catch (error) {
      console.error("Error fetching companies:", error);
      showSnackbar("Failed to load company list", "error");
    }
  };

  const fetchDistributors = async (companyId) => {
      try {
        // const response = await get(
        //   `${API_URL}/api/operators/vendor/${vendorId}/getDistributorsListByCompanyId`,
        //   { params: { companyId } }
        // );
        const response = await get(`${API_URL}/api/operators/vendor/${vendorId}/getOperatorAccountTypeList`, {params: {accountTypes: "OWNER,DISTRIBUTOR", companyId: companyId}});
  
        // ✅ Your API returns array directly
        if (Array.isArray(response?.data)) {
          if (response.length === 0) {
            showSnackbar("No Distributors List present for this Company", "error");
          }
          setDistributorsList(response?.data);
        } else {
          console.error("Unexpected API response:", response);
          showSnackbar("Failed to load Distributors list", "error");
        }
      } catch (error) {
        console.error("Error fetching Distributors:", error);
  
        if (error?.response?.status === 404) {
          showSnackbar("No Distributors List present for this Company", "error");
        } else {
          showSnackbar("Failed to load Distributors list", "error");
        }
      }
    };
  // const fetchFranchisees = async (companyId) => {
  //   try {
  //     const response = await get(`${API_URL}/api/franchisees/vendor/${vendorId}/findByCompanyId`, { params: { companyId } });
  //     if (response && response && Array.isArray(response?.data)) {
  //       setFranchisees(response?.data);
  //     } else {
  //       console.error("Unexpected API response:", response);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching franchisees:", error);
  //     showSnackbar("Failed to load franchise list", "error");
  //   }
  // };

  const fetchFranchisees = async (companyId) => {
    try {
        const response = await get(
            `${API_URL}/api/franchisees/vendor/${vendorId}/findByCompanyId`,
            { params: { companyId } }
        );

        if (Array.isArray(response?.data)) {
            setFranchisees(response.data);
            return response.data;   // <-- IMPORTANT
        }

        return [];
    } catch (e) {
        return [];
    }
};

  const fetchRoles = async () => {
    try {

      let response = null;
      if (accountType !== null && accountType !== undefined && accountType.trim() === "DISTRIBUTOR") {
        response = await get(`${API_URL}/api/globalRole/vendor/${vendorId}/findAllDistributorRoles`);
      } else {
        response = await get(`${API_URL}/api/globalRole/vendor/${vendorId}/franchise/${franchiseId}/findAll`);
      }

      //const response = await get(`${API_URL}/api/globalRole/vendor/${vendorId}/franchise/${franchiseId}/findAll`);
      if (response && response.data && Array.isArray(response.data)) {
        setRoles(response.data);   // << Use data.data
      } else {
        console.error("Unexpected API response:", response);
      }
    } catch (error) {
      console.error("Error fetching roles:", error);
      showSnackbar("Failed to load roles list", "error");
    }
  };

  const fetchPriceListByVendor = async () => {
      try {
        const response = await get(
          `${API_URL}/api/area-wise-price-list/vendor/${vendorId}/getPriceListsByVendorId`
        );
  
        console.log("Price List API Response:", response);
        if (response?.data && Array.isArray(response.data)) {
          setPriceLists(response.data);
        } else {
          setPriceLists([]);
        }
  
      } catch (error) {
        console.error("Error fetching price list:", error);
        setPriceLists([]);
      }
    };
  
    const billingTaxType = async () => {
        try {
          const res = await get(
            `${API_URL}/api/billing-tax-type/vendor/${vendorId}/getAll`
          );
      
          if (res?.success && res?.data) {
            setBillingTaxTypes(res.data);
          }
        } catch (error) {
          console.error("Error fetching billing tax types", error);
        }
      };

  useEffect(() => {
     billingTaxType();
    fetchPriceListByVendor();
    //fetchCompanies();
    fetchRoles();
    setFranchisees([]);
  }, []);

  // Re-select Roles after rolesList loads
  useEffect(() => {
    if (rolesList.length > 0 && formData.roleIdsList.length > 0) {
      setFormData(prev => ({
        ...prev,
        roleIdsList: [...prev.roleIdsList]
      }));
    }
  }, [rolesList]);

  // Re-select Franchisees after franchiseList loads
  useEffect(() => {
    if (franchiseList.length > 0 && formData.franchiseIdsList.length > 0) {
      setFormData(prev => ({
        ...prev,
        franchiseIdsList: [...prev.franchiseIdsList]
      }));
    }
  }, [franchiseList]);



  // Fetch user data when editing
  useEffect(() => {
    const fetchOperator = async () => {
      try {
        setLoading(true);

        const response = await get(`${API_URL}/api/operators/vendor/${vendorId}/getByOperatorId`, { params: { id } });

        const data = response?.data;
        await fetchDistributors(data.companyId);
        const franchises = await fetchFranchisees(data.companyId);

        const existFranchise = franchises.find(
            (f: any) => String(f.id) === String(data.franchiseId)
        );

        let companiesList = await fetchCompanies();
        const selectedCompany = companiesList.find((c) => c.id === data?.companyId);

        setFormData({
          ...data, // ✅ VERY IMPORTANT
          roleIdsList: data.rolesList?.map(r => r.roleId) || [],
          franchiseIdsList: data.franchiseList?.map(f => f.franchise.id) || [],
          franchiseName: existFranchise?.name || "",
          franchiseCode: existFranchise?.franchiseeCode || "",
          billingTaxId: existFranchise?.billingTaxId || "",
          priceListId: existFranchise?.priceListId || "",
          openingAmount: existFranchise?.openingAmount || "",
          creditLimit: existFranchise?.creditLimit || "",
          status: (data.status === "ACTIVE"),
          company: (selectedCompany ? selectedCompany.companyName : '')
        });

        
      } catch (error) {
        console.error("Error fetching operator:", error);
      } finally {
        setLoading(false);
      }
    };


    if (id) fetchOperator();
  }, [id]);



  // Fetch all states on load
  /*  useEffect(() => {
     const fetchStates = async () => {
       try {
         const response = await get(`${API_URL}/states`);
         setStates(response || []);
       } catch (error) {
         console.error("Error fetching states:", error);
       }
     };
     fetchStates();
   }, []); */

  // Fetch cities based on selected state
  /*  useEffect(() => {
     if (!formData.state) return;
     const fetchCities = async () => {
       setLoadingCities(true);
       try {
         const response = await get(`${API_URL}/cities?stateName=${formData.state}`);
         setCities(response || []);
       } catch (error) {
         console.error("Error fetching cities:", error);
         setCities([]);
       } finally {
         setLoadingCities(false);
       }
     };
     fetchCities();
   }, [formData.state]);
  */


  const fetchAreas = async () => {
    try {
      const response = await get(`${API_URL}/api/miscellaneous/area/vendor/${vendorId}/findAll`);
      if (response) setAreaList(response?.data);
      console.log('city', response?.data)
    } catch (error) {
      console.error("Error fetching areas", error);
    }
  };
  const fetchZones = async () => {
    try {
      const response = await get(`${API_URL}/api/miscellaneous/zone/vendor/${vendorId}/findAll`);
      if (response) setZonesList(response?.data);
      //console.log('city',response?.data)
    } catch (error) {
      console.error("Error fetching areas", error);
    }
  };
  React.useEffect(() => {
    fetchAreas();
    //fetchZones();
  }, []);


  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    // Reset city when state changes
    if (name === "state") {
      setFormData((prev) => ({ ...prev, state: value, city: "" }));
    }
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleCheckboxChange = (franchisee: string) => {
    setFormData((prev) => {
      const isSelected = prev.franchisees.includes(franchisee);
      const updatedList = isSelected
        ? prev.franchisees.filter((f) => f !== franchisee)
        : [...prev.franchisees, franchisee];
      return { ...prev, franchisees: updatedList };
    });
  };

  const handleSelectAll = () => {
    setFormData((prev) => ({
      ...prev,
      selectAll: !prev.selectAll,
      franchisees: prev.selectAll ? [] : [...franchiseeList],
    }));
  };

  const handleSwitchChange = (e: any) => {
    const { name, checked } = e.target;
    setFormData((prev) => ({ ...prev, [name]: checked }));
  };

  // const handleChange = (e: any) => {
  //   const { name, value } = e.target;
  //   setFormData((prev) => ({ ...prev, [name]: value }));
  // };

  // const handleCheckboxChange = (franchisee: string) => {
  //   setFormData((prev) => {
  //     const isSelected = prev.franchisees.includes(franchisee);
  //     const updatedList = isSelected
  //       ? prev.franchisees.filter((f) => f !== franchisee)
  //       : [...prev.franchisees, franchisee];
  //     return { ...prev, franchisees: updatedList };
  //   });
  // };

  // const handleSelectAll = () => {
  //   setFormData((prev) => ({
  //     ...prev,
  //     selectAll: !prev.selectAll,
  //     franchisees: prev.selectAll ? [] : [...franchiseeList],
  //   }));
  // };

  // const handleSwitchChange = (e: any) => {
  //   const { name, checked } = e.target;
  //   setFormData((prev) => ({ ...prev, [name]: checked }));
  // };

  useEffect(() => {
    if (operatorAccountType === "DISTRIBUTOR") {
      setFormData(prev => ({ ...prev, accountType: "LCO" }));
    }
  }, [operatorAccountType]);

  const handleSubmit = async () => {

    if (!validate()) return; // stop submit if invalid
    setLoading(true);
    try {
      
      // formData.vendorId = vendorId;
      // formData.franchiseId = franchiseId;
      console.log('operatorId', id)
      const payload = {
        ...formData,
        id,
        lcoId: isLcoId ? formData.lcoId : null,
        status: formData.status,
        accountType:
          operatorAccountType === "DISTRIBUTOR"
            ? "LCO"
            : formData.accountType

      };
      const response = await put(`${API_URL}/api/operators/${id}`, payload);
      console.log('response', response)
      showSnackbar("Updated Successfully", "success");
      navigate('/Operator/operator');

    } catch (error) {
      console.error("Error updating user:", error);
      showSnackbar(error?.response?.data?.message ||
        error?.message ||
        "Update failed", "error");

    } finally {
      setLoading(false);
    }
  };

  const validate = () => {
    let tempErrors: { [key: string]: string } = {};

    if (!formData.companyId) tempErrors.companyId = "Company is required";
    //if (!formData.role) tempErrors.role = "Role is required";
    if (!formData.operatorName.trim()) {
      tempErrors.operatorName = "Name is required";
    } else if (formData.operatorName.trim().length < 3) {
      tempErrors.operatorName = "Name must be at least 3 characters";
    }
    if (!formData.accountType) tempErrors.accountType = "Account Type is required";
    //if (!formData.country) tempErrors.country = "Country is required";
    //if (!formData.state) tempErrors.state = "State is required";
    //if (!formData.zone) tempErrors.zone = "Zone is required";
    //if (!formData.city) tempErrors.city = "City is required";
    if (!formData.email) tempErrors.email = "Email is required";
    else if (!/\S+@\S+\.\S+/.test(formData.email)) tempErrors.email = "Enter a valid email";
    if (!formData.password) tempErrors.password = "Password is required";
    else if (formData.password.length < 6) tempErrors.password = "Password must be at least 6 characters";
    if (formData.roleIdsList.length === 0) tempErrors.roleIdsList = "Select at least one role";

    // if (accountType === "OWNER" && formData.franchiseIdsList.length === 0) {
    //   tempErrors.franchiseIdsList = "Select at least one franchise";
    // }

    if (
      operatorAccountType === "OWNER" &&
      formData.accountType === "LCO" &&
      !formData.distributorId
    ) {
        tempErrors.distributorId = "Distributor is required";
    }

    // if (
    //   operatorAccountType === "OWNER" &&
    //   formData.accountType === "DISTRIBUTOR" && !formData.franchiseId
    // ) {
    //     tempErrors.franchiseId = "Franchise is required";
    // }

    if (formData.accountType === "DISTRIBUTOR" && !formData.priceListId) {
      tempErrors.priceListId = "Price Template is required";
    }
    if (!formData.phone) {
  tempErrors.phone = "Phone number is required";
} else if (!/^\d{10}$/.test(formData.phone)) {
  tempErrors.phone = "Phone number must be 10 digits";
}

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  //const handleCancel = () => onClose();
  const handleCancel = () => {


    navigate('/Operator/operator');
  };
  const handleRolesChange = (event) => {
    const { value } = event.target;

    setErrors((prev) => ({
      ...prev,
      roleIdsList: "",
    }));
  }

  const handleInputChange = useCallback(
    debounce((value) => {
      setSelectedBillingAreaId(value);
    }, 400),
    []
  );

  return (
    <Paper
      elevation={3}
      sx={{
        p: 4,
        marginX: 2
        // backgroundColor: '#9ba1b0ff', // subtle gray background
        // color: '#0f0f0fff',
      }}
    >
      <Typography variant="h3" fontWeight="bold" gutterBottom>
        Edit Operator
      </Typography>
      <br />
      <Grid container spacing={3}>
        {/* Company, Role, Name */}

        {
          operatorAccountType == "OWNER" && <Grid item xs={12} md={3}>
            <FormControl fullWidth error={!!errors.company}>
              <InputLabel>Company</InputLabel>
              <Select
                name="companyId"
                value={formData.companyId}
                label="Company"
                onChange={(e) => {
                  const selectedId = e.target.value;
                  const selectedCompany = companiesList.find((c) => c.id === selectedId);
                  fetchFranchisees(selectedId);
                  fetchDistributors(selectedId);
                  setFormData((prev) => ({
                    ...prev,
                    companyId: selectedId,
                    distributorId: "",
                    franchiseId: "",
                    franchiseIdsList: [],
                    company: selectedCompany ? selectedCompany.companyName : '', // 👈 Store name too
                  }));


                }}
              >
                <MenuItem value="">Select Company</MenuItem>
                {companiesList.map((company) => (
                  <MenuItem key={company.id} value={company.id}>
                    {company.companyName}
                  </MenuItem>
                ))}
              </Select>
              {errors.companyId && <FormHelperText>{errors.companyId}</FormHelperText>}
            </FormControl>
          </Grid>
        }


        <Grid item xs={12} md={3}>
          <FormControl fullWidth error={!!errors.roleIdsList}>
            <InputLabel>Roles</InputLabel>
            <Select
              name="roleIdsList"
              multiple
              value={formData.roleIdsList}
              onChange={(e) => {
                const { value } = e.target;
                setFormData((prev) => ({ ...prev, roleIdsList: typeof value === "string" ? value.split(",") : value }));
                setErrors((prev) => ({ ...prev, roleIdsList: "" }));
              }}
              label="Roles"
              renderValue={(selected) =>
                rolesList
                  .filter((rle) => selected.includes(rle.id))
                  .map((rle) => rle.name)
                  .join(", ")
              }
            >
              {rolesList.map((rle) => (
                <MenuItem key={rle.id} value={rle.id}>
                  <Checkbox checked={formData.roleIdsList.indexOf(rle.id) > -1} />
                  {rle.name}
                </MenuItem>
              ))}
            </Select>
            {errors.roleIdsList && <FormHelperText>{errors.roleIdsList}</FormHelperText>}
          </FormControl>
        </Grid>


        <Grid item xs={12} md={3}>
          <TextField
            label="Name"
            name="operatorName"
            fullWidth
            value={formData.operatorName}
            onChange={handleChange}
            error={!!errors.operatorName}
            helperText={errors.operatorName}
          />
        </Grid>

        {

          <Grid item xs={12} md={3}>
            Account Type: {formData.accountType}
            {/* <FormControl fullWidth error={!!errors.accountType}>
              <InputLabel>Account Type</InputLabel>
              <Select name="accountType" value={formData.accountType} onChange={handleChange}>
                <MenuItem value="DISTRIBUTOR">Distributor</MenuItem>
                <MenuItem value="LCO">LCO</MenuItem>
              </Select>
              {errors.accountType && <FormHelperText>{errors.accountType}</FormHelperText>}
            </FormControl> */}
          </Grid>
        }


        {operatorAccountType === "OWNER" && formData.accountType === "LCO" && (
        
                  <Grid item xs={12} md={3}>
                      <FormControl fullWidth error={!!errors.distributorId}>
                          <InputLabel>Distributor</InputLabel>
        
                          <Select
                              name="distributorId"
                              value={formData.distributorId}
                              label="Distributor"
                              onChange={handleChange}
                          >
                              <MenuItem value="">
                                  Select Distributor
                              </MenuItem>
        
                              {distributorsList.map((d:any) => (
                                  <MenuItem key={d.id} value={d.id}>
                                      {d.operatorName}
                                  </MenuItem>
                              ))}
                          </Select>
        
                          {errors.distributorId &&
                              <FormHelperText>{errors.distributorId}</FormHelperText>}
                      </FormControl>
                  </Grid>
        
                  )}
        
                  {operatorAccountType === "OWNER" && formData.accountType === "DISTRIBUTOR" && (
        
                    <Grid item xs={12} md={3}>
                      <FormControl fullWidth>
                          <InputLabel>Franchise</InputLabel>
        
                          <Select
    name="franchiseId"
    value={formData.franchiseId}
    label="Franchise"
    onChange={(e) => {
        const franchiseId = e.target.value;

        const selectedFranchise = franchiseList.find(
            (f: any) => f.id === franchiseId
        );

        setFormData(prev => ({
            ...prev,
            franchiseId,

            franchiseName: selectedFranchise?.name || "",
            franchiseCode: selectedFranchise?.franchiseeCode || "",
            billingTaxId: selectedFranchise?.billingTaxId || "",
            priceListId: selectedFranchise?.priceListId || "",
            openingAmount: selectedFranchise?.openingAmount || "",
            creditLimit: selectedFranchise?.creditLimit || ""
        }));
    }}
>
    {franchiseList.map((f: any) => (
        <MenuItem key={f.id} value={f.id}>
            {f.name}
        </MenuItem>
    ))}
</Select>
        
                          {/* {errors.franchiseIdsList &&
                              <FormHelperText>{errors.franchiseId}</FormHelperText>} */}
                      </FormControl>
                  </Grid>
        
                    )}

        {/* Contact Info */}
        <Grid item xs={12} md={3}>
          <TextField label="Email" name="email" fullWidth value={formData.email} onChange={handleChange} error={!!errors.email} helperText={errors.email} disabled />
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField label="Password" name="password" 
          type={showPassword ? "text" : "password"}
          fullWidth value={formData.password} onChange={handleChange} error={!!errors.password} helperText={errors.password}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={() => setShowPassword((prev) => !prev)}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
     />
        </Grid>
        {/* <Grid item xs={12} md={6}>
          <TextField label="Mobile" name="mobile" fullWidth value={formData.mobile} onChange={handleChange} />
        </Grid> */}
        <Grid item xs={12} md={3}>
          <TextField
  label="Phone"
  name="phone"
  fullWidth
  value={formData.phone}
  onChange={(e) => {
    const value = e.target.value.replace(/\D/g, ""); // Only digits

    setFormData((prev) => ({
      ...prev,
      phone: value,
    }));

    setErrors((prev) => ({
      ...prev,
      phone: "",
    }));
  }}
  error={!!errors.phone}
  helperText={errors.phone}
  inputProps={{
    maxLength: 10,
    inputMode: "numeric",
  }}
/>
        </Grid>
        
        {/* Franchisee List */}
        {/* {errors.franchiseIdsList && (
          <Typography color="error" variant="caption">
            {errors.franchiseIdsList}
          </Typography>
        )}
        {
          operatorAccountType == "OWNER" && <Grid item xs={12}>
            <Typography variant="subtitle1" sx={{ mb: 1 }}>
              Franchisee List
            </Typography>

            <Box
              sx={{
                border: "1px solid #444",
                borderRadius: "6px",
                padding: "12px",
                maxHeight: "140px", // Show ~4 rows before scroll
                overflowY: "auto",
                display: "flex",
                flexWrap: "wrap",
                gap: "12px"
              }}
            >
              {/* Select All *
              <FormControlLabel
                control={
                  <Checkbox
                    checked={
                      formData.franchiseIdsList.length === franchiseList.length &&
                      franchiseList.length > 0
                    }
                    onChange={() => {
                      if (formData.franchiseIdsList.length === franchiseList.length) {
                        setFormData((prev) => ({ ...prev, franchiseIdsList: [] }));
                      } else {
                        setFormData((prev) => ({
                          ...prev,
                          franchiseIdsList: franchiseList.map((f) => f.id)
                        }));
                      }
                    }}
                  />
                }
                label="Select All"
                sx={{ width: "100%" }}
              />

              {/* Franchise Checkboxes *
              {franchiseList.map((f) => (
                <FormControlLabel
                  key={f.id}
                  control={
                    <Checkbox
                      checked={formData.franchiseIdsList.includes(f.id)}
                      onChange={(e) => {
                        const { checked } = e.target;
                        setFormData((prev) => ({
                          ...prev,
                          franchiseIdsList: checked
                            ? [...prev.franchiseIdsList, f.id]
                            : prev.franchiseIdsList.filter((id) => id !== f.id)
                        }));
                      }}
                    />
                  }
                  label={f.name}
                />
              ))}
            </Box>

            {errors.franchiseIdsList && (
              <Typography color="error" variant="caption">
                {errors.franchiseIdsList}
              </Typography>
            )}
          </Grid>
        } */}


        {/* <Grid item xs={12}>
          <Divider sx={{ my: 1 }} />
          <Typography variant="h6">Franchisee List</Typography>
          <FormControlLabel
            control={<Checkbox checked={formData.selectAll} onChange={handleSelectAll} />}
            label="Select All"
          />
          <Grid container>
            {franchiseeList.map((f) => (
              <Grid item xs={6} md={3} key={f}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={formData.franchisees.includes(f)}
                      onChange={() => handleCheckboxChange(f)}
                    />
                  }
                  label={f}
                />
              </Grid>
            ))}
          </Grid>
        </Grid> */}

        {/* Address Info */}


        <Grid item xs={12} md={3}>
          <TextField label="Address" name="address1" fullWidth value={formData.address1} onChange={handleChange} />
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField label="Landmark/Village" name="address2" fullWidth value={formData.address2} onChange={handleChange} />
        </Grid>
        {/* <Grid item xs={12} md={6}>
          <TextField label="Address 3" name="address3" fullWidth value={formData.address3} onChange={handleChange} />
        </Grid> */}

        {
          operatorAccountType == "OWNER" && <Grid item xs={6} >

            <Autocomplete
              options={areaList}
              loading={!areaList.length}

              // ✅ control dropdown
              open={areaOpen}
              onClose={() => setAreaOpen(false)}

              value={
                areaList.find(
                  (a) => String(a.id) === String(formData.areaId)
                ) ?? null
              }

              getOptionLabel={(option) =>
                `${option.name} / ${option.districtName} / ${option.cityName} / ${option.stateName} / ${option.countryName} / ${option.zipCode}`
              }

              isOptionEqualToValue={(option, value) =>
                String(option.id) === String(value.id)
              }

              onChange={(_, newValue) => {
                setFormData((prev) => ({
                  ...prev,
                  areaId: newValue ? newValue.id : '',
                  areaName: newValue ? newValue.cityName : ''
                }));
              }}

              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Area (City)"
                  fullWidth
                  error={!!errors.areaId}
                  helperText={errors.areaId}

                  // ✅ open on first click
                  onClick={() => setAreaOpen(!areaOpen)}

                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {!areaList.length && <CircularProgress size={18} />}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                />
              )}
            />
          </Grid>
        }



        {/* <Grid item xs={12} md={6}>
          <TextField label="Postal Code" name="postalCode" fullWidth value={formData.postalCode} onChange={handleChange} />
        </Grid> */}

        

        {/* <Grid item xs={12} md={3}>
          <FormControl fullWidth error={!!errors.country}>
            <InputLabel>Country</InputLabel>
            <Select name="country" value={formData.country} onChange={handleChange}>
              <MenuItem value="India">India</MenuItem>
              <MenuItem value="USA">United States</MenuItem>
              <MenuItem value="UK">United Kingdom</MenuItem>
              <MenuItem value="Canada">Canada</MenuItem>
              <MenuItem value="Australia">Australia</MenuItem>
              <MenuItem value="Germany">Germany</MenuItem>
            </Select>
            {errors.country && <FormHelperText>{errors.country}</FormHelperText>}
          </FormControl>
        </Grid> */}

        {/* <Grid item xs={12} md={3}>
           <FormControl fullWidth error={!!errors.state}>
            <InputLabel>State</InputLabel>
            <Select name="state" value={formData.state} onChange={handleChange}>
              {states.length > 0 ? (
                states.map((state) => (
                  <MenuItem key={state} value={state}>
                    {state}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>No States Found</MenuItem>
              )}
            </Select>
            {errors.state && <FormHelperText>{errors.state}</FormHelperText>}
          </FormControl>
        </Grid> */}

        {/* <Grid item xs={12} md={3}>
          <FormControl fullWidth error={!!errors.zone}>
            <InputLabel>Zone</InputLabel>
            <Select
              name="zone"
              value={formData.zone || ''}
              onChange={handleChange}
              label="Zone"
            >
              {zonesList.map((zone) => (
                <MenuItem key={zone.id} value={zone.id}>
                  {zone.name}
                </MenuItem>
              ))}
            </Select>
            {errors.zone && <FormHelperText>{errors.zone}</FormHelperText>}
          </FormControl>
        </Grid> */}

        {isLcoId && (
  <Grid item xs={12} md={3}>
    <TextField
      label="LCO ID"
      name="lcoId"
      fullWidth
      value={formData.lcoId}
      onChange={handleChange}
    />
  </Grid>
)}

        {/* <Grid item xs={12} md={3}>
          <FormControl fullWidth error={!!errors.city}>
            <InputLabel>City</InputLabel>
            <Select
              name="city"
              value={formData.city}
              onChange={handleChange}
              disabled={!formData.state || loadingCities}
            >
              {loadingCities ? (
                <MenuItem disabled>Loading...</MenuItem>
              ) : cities.length > 0 ? (
                cities.map((city) => (
                  <MenuItem key={city} value={city}>
                    {city}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>No Cities Found</MenuItem>
              )}
            </Select>
            {errors.city && <FormHelperText>{errors.city}</FormHelperText>}
          </FormControl>
        </Grid> */}
{formData.accountType === "DISTRIBUTOR" && (
  <>
        <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    fullWidth
                    label="Franchise Name"
                    name="franchiseName"
                    value={formData.franchiseName}
                    onChange={handleChange}
                  />
                </Grid>
        
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    fullWidth
                    label="Franchise Code"
                    name="franchiseCode"
                    value={formData.franchiseCode}
                    onChange={handleChange}
                  />
                </Grid>
                
                <Grid item xs={12} sm={6} md={3}>
                  <FormControl fullWidth error={!!errors.priceListId}>
                    <InputLabel>Franchisee PriceList*</InputLabel>
                    <Select
                      name="priceListId"
                      value={formData.priceListId}
                      label="Franchisee PriceList*"
                      onChange={handleChange}
                    // disabled={priceLists.length === 0}
                    >
                      <MenuItem value="">Select Price List</MenuItem>
                      {priceLists.map((p) => (
                        <MenuItem key={p.id} value={p.id}>
                          {p.areaName} - {p.locationName}
                        </MenuItem>
                      ))}
                    </Select>
                    {errors.priceListId && <FormHelperText error>{errors.priceListId}</FormHelperText>}
                  </FormControl>
                </Grid>
        
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    select
                    fullWidth
                    label="Billing Tax Type"
                    name="billingTaxId"
                    value={formData.billingTaxId}
                    onChange={handleChange}
                   
                  >
                    {billingTaxTypes.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.name}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
        
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    fullWidth
                    label="Opening Amount"
                    name="openingAmount"
                    type="number"
                    value={formData.openingAmount}
                    onChange={handleChange}
                  />
                </Grid>
        
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    fullWidth
                    label="Credit Limit"
                    name="creditLimit"
                    type="number"
                    value={formData.creditLimit}
                    onChange={handleChange}
                  />
                </Grid>
</>
)}
        {/* Switches */}
        <Grid item xs={12}>
          <Divider sx={{ my: 1 }} />
          <FormControlLabel
            control={<Switch checked={formData.enableFreeAccess} onChange={handleSwitchChange} name="enableFreeAccess" />}
            label="Free Enable"
          />
          
          <FormControlLabel
            control={<Switch checked={formData.allowLowBalanceRecharge} onChange={handleSwitchChange} name="allowLowBalanceRecharge" />}
            label="Allowed Low Balance Recharge"
          />
          <FormControlLabel
            control={<Switch checked={formData.status} onChange={handleSwitchChange} name="status" />}
            label="Status (Active)"
          />
        </Grid>

        {/* Buttons */}
        <Grid item xs={12} sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
          <Button
  variant="contained"
  color="primary"
  sx={{ mr: 2 }}
  onClick={handleSubmit}
  disabled={loading}
  startIcon={
    loading ? <CircularProgress size={20} color="inherit" /> : null
  }
>
  {loading ? "Updating..." : "Update"}
</Button>
          <Button variant="outlined" color="secondary" onClick={handleCancel}>
            Cancel
          </Button>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default EditOperator;